import React, { useMemo, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { sgzMarkerDataSelector } from '../markers/state/sgzMarkerDataSelector'
import { sgzMarkerRealTimeSelector } from '../markers/state/sgzMarkerRealTimeSelector'

import { toggleSgzSpecificDetailPanel } from '../detailsPanel/state/displaySgzSpecificDetailPanelAction'
import { toggleParkingSpecificDetailPanel } from '../detailsPanel/state/displayParkingSpecificDetailPanelAction'
import { hideDetailPanelContainer } from '../detailsPanel/state/displayDetailsPanelContainerAction'
import { toggleLvzSpecificDetailPanel } from '../detailsPanel/state/displayLvzSpecificDetailPanelAction'

import LiveViewZoneMarker from './LiveViewZoneMarker'
import store from '../store/index'

function WrapperStreetGaugeZone({map}) {

    const sgzMarkerData = useSelector(sgzMarkerDataSelector)
    const sgzMarkerRealTime = useSelector(sgzMarkerRealTimeSelector)

    const handleSgzClick = useCallback((streetId) => {
        store.dispatch(toggleSgzSpecificDetailPanel({ value: true, streetId }))
        store.dispatch(hideDetailPanelContainer())
        store.dispatch(toggleParkingSpecificDetailPanel(false))
        store.dispatch(toggleLvzSpecificDetailPanel({ value: false, lvzId: "" }))
    }, [])

    const markers = useMemo(() => {
        return Object.keys(sgzMarkerData).map((streetId) => {
            const staticData = sgzMarkerData[streetId]
            const dynamicData = sgzMarkerRealTime[streetId]

            if (!staticData || !staticData.location) return null

            const position = {
                lat: staticData.location.lat,
                lng: staticData.location.lng
            }

            const availability = dynamicData?.availability || 'deactivate'
            const freeSlot = dynamicData?.free_slots || 0
            const activated = dynamicData?.activated ?? staticData?.activated ?? false
            const polygon = staticData.coordinates || staticData.polygon || []

            return (
                <LiveViewZoneMarker
                    position={position}
                    availability={availability}
                    freeSlot={freeSlot}
                    key={streetId}
                    path={polygon}
                    zoneId={streetId}
                    activated={activated}
                    map={map}
                    entityType="street_gauge"
                    marker={streetId}
                    onClickOverride={handleSgzClick}
                />
            )
        });
    }, [sgzMarkerData, sgzMarkerRealTime, map, handleSgzClick])

    return (
        <div>
            {markers}
        </div>
    )
}

export default WrapperStreetGaugeZone
